/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AlignTextRight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14 1.4a.6.6 0 1 1 0 1.2H2a.6.6 0 1 1 0-1.2h12ZM14 13.4a.6.6 0 0 1 0 1.2H8a.6.6 0 1 1 0-1.2h6ZM14.6 10a.6.6 0 0 0-.6-.6H2a.6.6 0 1 0 0 1.2h12a.6.6 0 0 0 .6-.6ZM14 5.4a.6.6 0 1 1 0 1.2H5a.6.6 0 1 1 0-1.2h9Z" /></svg>;
}
;